import { EnhancedRouteProps } from 'router/routes/Enhanced/Enhanced.route';
import Page from './pages/SponsoredAdverts';

export default [{ index: true, element: Page }] as Array<EnhancedRouteProps>;
